import { SearchOutlined } from '@vindr/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface SearchFilter {
  onClick(...args: unknown[]): unknown;
  title?: string;
  className?: string;
}

const SearchFilter = ({ onClick, title, className }: SearchFilter) => {
  const { t } = useTranslation('Vindoc');
  title = title || t('Search');

  return (
    <div className="filter-items flex items-end">
      <Button
        size="small"
        type="primary"
        className={twMerge('flex items-center', className)}
        onClick={onClick}
        icon={<SearchOutlined />}
      >
        {title}
      </Button>
    </div>
  );
};

export default SearchFilter;
